/**
 * Data Linker — applies data source values to project item fields
 */
import { dataStore } from '../stores/dataStore';
import { projectStore } from '../stores/projectStore';
import { eventBus } from './eventBus';

export function initDataLinker(): void {
  // When a data source row changes, update all linked fields
  eventBus.on('data:rowChanged', ({ sourceId }) => {
    const links = dataStore.getState().links.filter((l) => l.dataSourceId === sourceId);
    for (const link of links) {
      const value = dataStore.getState().getLinkedValue(link);
      if (value !== undefined) {
        projectStore.getState().updateField(link.projectItemId, link.fieldId, value);
      }
    }
  });

  // When a new link is created, immediately apply the current value
  eventBus.on('data:linkCreated', ({ link }) => {
    const value = dataStore.getState().getLinkedValue(link);
    if (value !== undefined) {
      projectStore.getState().updateField(link.projectItemId, link.fieldId, value);
    }
  });
}

/**
 * Parse CSV text into rows
 */
export function parseCSV(csvText: string): { columns: string[]; rows: Record<string, string>[] } {
  const lines = csvText.trim().split('\n').map((l) => l.trim());
  if (lines.length === 0) return { columns: [], rows: [] };

  const columns = lines[0].split(',').map((c) => c.trim());
  const rows = lines.slice(1).map((line) => {
    const values = line.split(',').map((v) => v.trim());
    const row: Record<string, string> = {};
    columns.forEach((col, i) => {
      row[col] = values[i] ?? '';
    });
    return row;
  });

  return { columns, rows };
}
